import Icon from '../components/Icon.vue'

Icon.register({
  'camera-retro': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M48 32h416c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48zM48 64c-8.8 0-16 7.2-16 16v10c0 3.3 2.7 6 6 6h116c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6h-106zM474 160c3.3 0 6-2.7 6-6v-74c0-8.8-7.2-16-16-16h-252.8c-2 0-3.9 1-5 2.7l-30.2 45.3h-138c-3.3 0-6 2.7-6 6v36c0 3.3 2.7 6 6 6h436zM256 424c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120 53.8 120 120 120zM256 216c48.5 0 88 39.5 88 88s-39.5 88-88 88-88-39.5-88-88 39.5-88 88-88zM208 320c8.8 0 16-7.2 16-16 0-17.6 14.4-32 32-32 8.8 0 16-7.2 16-16s-7.2-16-16-16c-35.3 0-64 28.7-64 64 0 8.8 7.2 16 16 16z'
      }
    ]
  }
})
